<template>
  <div class="pt-4 px-4 pb-20">
    <h1 class="text-3xl font-bold mb-5">
      {{ $t('positions') }}
    </h1>

    <div class="mb-3">
      <div class="">
        <nav class="flex space-x-4" aria-label="Tabs">
          <a
              v-for="tab in tabs"
              :key="tab.key"
              href="javascript:void(0)"
              @click="onChangeTab(tab)"
              :class="[tab.key === this.activeTab
                ? `${$theme.activeTabBg} ${$theme.activeTabBorder} ${$theme.activeTabTextColor}`
                : `${$theme.tabTextColor} border-transparent opacity-70`,
                'rounded-lg px-3 py-2 border text-sm font-medium'
              ]"
          >
            {{ tab.name }}
            <template v-if="tab.key === 'open'">({{ postions.length }})</template>
          </a>
        </nav>
      </div>
    </div>

    <template v-if="activeTab === 'open'">
      <template v-if="loading">
        <div class="mb-3">
          <OrderItemPlaceholder />
        </div>
        <div class="mb-3">
          <OrderItemPlaceholder />
        </div>
      </template>
      <template v-else>
        <template v-if="postions.length">
          <div v-for="position in postions" :key="position.id" class="mb-3">
            <OrderItem :order="position" :is_edit="true" @close-position="onClosedPosition" />
          </div>
        </template>
        <template v-else>
          <template v-if="$user.is_auto_trade">
            <AIPlaceholder />
          </template>
          <template v-else>
            <div class="rounded-xl overflow-hidden px-4 py-4" :class="[$theme.cardBg]">
              <p class="text-center">{{ $t('autotrade_off_message') }}</p>
            </div>
          </template>
          <!--<div class="rounded-xl overflow-hidden px-4 py-4" :class="[$theme.cardBg]">
            <p class="text-center">{{ $t('no_active_positions') }}</p>
          </div>-->
        </template>
      </template>
    </template>

    <template v-if="activeTab === 'history'">
      <template v-if="loadingHistory">
        <div class="mb-3">
          <OrderItemPlaceholder />
        </div>
        <div class="mb-3">
          <OrderItemPlaceholder />
        </div>
      </template>
      <template v-else>
        <template v-if="history.data.length">
          <div v-for="order in history.data" :key="order.id" class="mb-3">
            <OrderItem :order="order" />
          </div>
        </template>
        <template v-else>
          <div class="rounded-xl overflow-hidden px-4 py-4" :class="[$theme.cardBg]">
            <p class="text-center">{{ $t('no_history') }}</p>
          </div>
        </template>

        <template v-if="history.meta.last_page > this.historyParams.page">
          <button
              @click="onLoadHistoryMore"
              class="w-full text-sm py-3 rounded-xl font-medium"
              :class="[
                  loadingHistoryMore ? 'opacity-60 pointer-events-none' : '',
                  $theme.outlineBtnBg,
                  $theme.outlineBtnTextColor,
              ]"
          >
            <template v-if="loadingHistoryMore">
              <ButtonSpinnerBlue />
            </template>
            {{ $t('load_more') }}
          </button>
        </template>
      </template>
    </template>
  </div>
</template>

<script>
import OrderItem from "@/components/elem/OrderItem.vue";
import OrderItemPlaceholder from "@/components/placeholders/OrderItemPlaceholder.vue";
import ButtonSpinnerBlue from "@/components/ButtonSpinnerBlue.vue";
import AIPlaceholder from "@/components/placeholders/AIPlaceholder.vue";

export default {
  components: {
    OrderItem,
    ButtonSpinnerBlue,
    OrderItemPlaceholder,
    AIPlaceholder,
  },

  methods: {
    onChangeTab(tab) {
      this.activeTab = tab.key;

      if (this.activeTab === 'open') {
        this.loadOpenPositions();
      }

      if (this.activeTab === 'history') {
        this.loadHistoryOrder();
      }
    },

    onClosedPosition() {
      this.loadOpenPositions();
    },

    loadOpenPositions() {
      console.log('Load positions...');

      this.$api.get('/positions/opened').then((result) => {
        console.log('Loaded positions', result)
        this.postions = result.data.data;
        this.loading = false
      }).catch(e => {
        console.log(e)
        this.error = e
      })
    },

    loadHistoryOrder() {
      console.log('Load history orders...');

      this.loadingHistory = true;

      this.$api.get('/positions', {
        params: this.historyParams
      }).then((result) => {
        console.log(result.data);
        this.history = result.data;
        this.loadingHistory = false;
      }).catch(e => {
        console.log(e)
        this.error = e
      })
    },

    onLoadHistoryMore() {
      this.loadingHistoryMore = true;
      this.historyParams.page += 1;

      this.$api.get('/positions', {
        params: this.historyParams
      }).then((result) => {
        this.history.data = [...this.history.data, ...result.data.data];
        this.loadingHistoryMore = false;
      }).catch(e => {
        console.log(e);
        this.error = e;
      });
    },
  },

  data() {
    return {
      loading: true,
      loadingHistory: true,
      loadingHistoryMore: false,
      orders: [],
      postions: [],
      history: null,
      error: null,
      intervalId: null,
      activeTab: 'open',
      tabs: [
        { name: this.$t('open'), key: 'open' },
        { name: this.$t('history'), key: 'history' },
      ],
      historyParams: {
        user_id: this.$user.id,
        per_page: 10,
        page: 1
      },

      typeListenKey: 'create',
      listenKey: '',
    }
  },

  mounted() {
    this.loadOpenPositions()
    this.intervalId = setInterval(this.loadOpenPositions, 5000);
  },

  beforeUnmount() {
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
  }
}
</script>
